/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Organización en modal desde el hub post-login — volver al panel sin elegir sucursal.
 */
import React from 'react';
import { OrganizationScreen } from '../../settings/screens/OrganizationScreen';

export function HubOrganizationScreen() {
  return <OrganizationScreen />;
}
